import React, { useState, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import api from '../services/api';
import './Actualites.scss';

const Actualites = () => {
  const [articles, setArticles]       = useState([]);
  const [categories, setCategories]   = useState([]);
  const [loading, setLoading]         = useState(true);
  const [activeCategory, setCategory] = useState('Tous');
  const [selected, setSelected]       = useState(null);
  const [loadingDetail, setLoadDetail]= useState(false);

  useEffect(() => {
    Promise.all([
      api.get('/news'),
      api.get('/news/categories'),
    ]).then(([newsRes, catRes]) => {
      setArticles(newsRes.data.data || []);
      setCategories(['Tous', ...(catRes.data.data || [])]);
    }).catch(() => {
      setArticles([]);
    }).finally(() => setLoading(false));
  }, []);

  const filtered = activeCategory === 'Tous'
    ? articles
    : articles.filter(a => a.category === activeCategory);

  const openArticle = (article) => {
    if (article.content) {
      setSelected(article);
      return;
    }
    setLoadDetail(true);
    api.get(`/news/${article.slug}`)
      .then(({ data }) => setSelected(data.data))
      .catch(() => setSelected(article))
      .finally(() => setLoadDetail(false));
  };

  const events = [
    { id: 1, title: 'Webinaire : Réussir son orientation académique', date: '25 Mars 2026', time: '14h00 - 16h00', location: 'En ligne', type: 'Webinaire', status: 'À venir' },
    { id: 2, title: 'Journée Portes Ouvertes - Programme PROPEL',     date: '30 Mars 2026', time: '9h00 - 17h00',  location: 'Cocody, Abidjan', type: 'Événement', status: 'À venir' },
    { id: 3, title: 'Cérémonie de remise des certificats CODE',        date: '5 Avril 2026', time: '10h00 - 13h00', location: 'Cocody, Abidjan', type: 'Cérémonie', status: 'À venir' },
  ];

  const [activeTab, setActiveTab] = useState('articles');

  return (
    <div className="actualites-page">
      <PageHeader 
        image="/assets/IMG/Header_Actualites.png"
        title="Actualités" 
        subtitle="Restez informé de nos dernières nouvelles et événements"
        breadcrumb={['Accueil', 'Actualités']}
        hideText={true}
      />

      <div className="actualites-container">
        <div className="tabs">
          <button className={`tab ${activeTab === 'articles' ? 'active' : ''}`} onClick={() => setActiveTab('articles')}>
            Articles
          </button>
          <button className={`tab ${activeTab === 'events' ? 'active' : ''}`} onClick={() => setActiveTab('events')}>
            Événements
          </button>
        </div>

        {activeTab === 'articles' && (
          <div className="articles-section">
            {categories.length > 1 && (
              <div className="category-filters">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`category-filter-btn ${activeCategory === cat ? 'active' : ''}`}
                    onClick={() => setCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            )}

            {loading ? (
              <div className="articles-grid">
                {[1, 2, 3].map((n) => (
                  <div key={n} className="article-card-skeleton" />
                ))}
              </div>
            ) : filtered.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '48px 20px', color: '#aaa' }}>
                <p>Aucun article dans cette catégorie.</p>
              </div>
            ) : (
              <div className="articles-grid">
                {filtered.map((article) => (
                  <div key={article.id} className="article-card">
                    <div className="article-image">
                      {article.image ? (
                        <img src={article.image} alt={article.title} onError={(e) => { e.target.style.display = 'none'; }} />
                      ) : (
                        <div className="image-placeholder">
                          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" stroke="#3B5BA5" strokeWidth="2">
                            <rect x="10" y="15" width="40" height="30" rx="2"/>
                            <path d="M10 25 L50 25"/>
                            <circle cx="18" cy="20" r="2" fill="#3B5BA5"/>
                          </svg>
                        </div>
                      )}
                      <span className="category-badge">{article.category}</span>
                    </div>
                    <div className="article-content">
                      <p className="article-date">{article.published_at || article.date}</p>
                      <h3>{article.title}</h3>
                      <p className="article-excerpt">{article.excerpt}</p>
                      <button className="read-more-btn" onClick={() => openArticle(article)}>
                        {loadingDetail ? 'Chargement…' : 'Lire la suite →'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'events' && (
          <div className="events-section">
            <div className="events-list">
              {events.map((event) => (
                <div key={event.id} className="event-card">
                  <div className="event-date-badge">
                    <span className="day">{event.date.split(' ')[0]}</span>
                    <span className="month">{event.date.split(' ')[1]}</span>
                  </div>
                  <div className="event-content">
                    <div className="event-header">
                      <h3>{event.title}</h3>
                      <span className={`status-badge ${event.status === 'À venir' ? 'upcoming' : ''}`}>
                        {event.status}
                      </span>
                    </div>
                    <div className="event-details">
                      <div className="detail-item">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <circle cx="8" cy="8" r="6"/>
                          <path d="M8 4 L8 8 L11 11"/>
                        </svg>
                        <span>{event.time}</span>
                      </div>
                      <div className="detail-item">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <circle cx="8" cy="7" r="3"/>
                          <path d="M8 14 C5 14 2 11 2 7 C2 4 5 1 8 1 C11 1 14 4 14 7 C14 11 11 14 8 14 Z"/>
                        </svg>
                        <span>{event.location}</span>
                      </div>
                      <div className="detail-item">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <rect x="3" y="4" width="10" height="9" rx="1"/>
                          <path d="M5 2 L5 4"/>
                          <path d="M11 2 L11 4"/>
                        </svg>
                        <span>{event.type}</span>
                      </div>
                    </div>
                    <button className="register-btn">S'inscrire</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {selected && (
        <div className="article-modal-overlay" onClick={() => setSelected(null)}>
          <div className="article-modal" onClick={(e) => e.stopPropagation()}>
            <button className="article-modal-close" onClick={() => setSelected(null)}>✕</button>
            {selected.image && (
              <img src={selected.image} alt={selected.title} className="article-modal-image" onError={(e) => { e.target.style.display = 'none'; }} />
            )}
            <div className="article-modal-body">
              <div className="article-modal-meta">
                <span className="category-badge">{selected.category}</span>
                <span className="article-date">{selected.published_at}</span>
                {selected.author && <span style={{ color: '#888', fontSize: 13 }}>Par {selected.author}</span>}
              </div>
              <h2>{selected.title}</h2>
              {selected.content ? (
                <div className="article-modal-content" dangerouslySetInnerHTML={{ __html: selected.content }} />
              ) : (
                <p>{selected.excerpt}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Actualites;
